import { DateUtils } from 'react-day-picker';
import moment from 'moment-timezone';
import DateHelper from '../../lib/utils/date';

export default {
  groupEventsByDate(events, month, timeZone) {
    const eventsByDate = {};
    const convertDateTimeToDate = (datetime, allDay) => {
      const m = DateHelper.isoStringToMoment(datetime, allDay, timeZone);
      return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute(), 0);
    };
    for (let i = 1; i <= 31; i++) {
      eventsByDate[i] = [];
      const day = moment(month).date(i);
      for (let j = 0; j < events.length; j++) {
        let eventAdded = false;
        const userEventSegments = events[j].node.user_event_segments.edges;
        for (let k = 0; k < userEventSegments.length; k++) {
          if (
            DateUtils.isDayInRange(day.toDate(), {
              from: convertDateTimeToDate(
                userEventSegments[k].node.start_at,
                userEventSegments[k].node.all_day
              ),
              to: convertDateTimeToDate(
                userEventSegments[k].node.end_at,
                userEventSegments[k].node.all_day
              )
            })
          ) {
            if (!eventAdded) eventsByDate[i].push(events[j]);
            eventAdded = true;
          }
        }
      }
    }
    return eventsByDate;
  }
};



// WEBPACK FOOTER //
// ./webpack/lib/utils/events.js